"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyedropper(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm14.8142.71076a2.07442 2.07442 0 0 0 -2.64724.29379l-2.04568 2.04568-.7071-.70709a1 1 0 0 0 -1.41418 1.41418l.70709.7071-6.53621 6.53621a2.46918 2.46918 0 0 0 -.52972.78781l-.92495 2.19681a.99148.99148 0 0 0 .21271 1.08582.99147.99147 0 0 0 1.08584.21269l2.19677-.925a2.46951 2.46951 0 0 0 .78776-.5297l6.53623-6.53623.70709.70717a1 1 0 1 0 1.41425-1.41425l-.70709-.70709 2.12123-2.12134a2.00133 2.00133 0 0 0 -.2568-3.04656zm-10.84264 12.44049-1.93946.81658.81665-1.93939 6.56543-6.56544 1.12287 1.1228z' })));
}
exports.default = SvgEyedropper;
